import SEO from "@/components/SEO";
import { SERVICES } from "@/lib/content";
import { ShieldCheck, Lock, Server, Globe, Palette, LifeBuoy, Check } from "lucide-react";
import { Link } from "react-router-dom";
import TestimonialCarousel from "@/components/TestimonialCarousel";

const iconMap = { ShieldCheck, Lock, Server, Globe, Palette, LifeBuoy };

const details = {
  "website-design": ["Conversion-focused UX", "Responsive & accessible", "SEO-ready structure", "Design system delivery"],
  "web-hosting": ["Managed hosting", "SSD/NVMe storage", "Auto-scaling ready", "Automated backups"],
  "ssl-certificates": ["DV / OV / EV", "Wildcard & SAN", "Free renewal reminders", "SSL Labs A+ target"],
  "domain-registration": ["Domain search & registration", "DNS management", "Domain privacy", "Bulk transfers"],
  "website-security": ["WAF setup", "Malware scanning", "24/7 monitoring", "Incident response"],
  "technical-support": ["Priority queues", "SLA-backed response", "Direct engineer access", "Runbooks & docs"],
};

export default function Services() {
  return (
    <>
      <SEO title="Services — Tech Alpha SSL" description="Website Design, Web Hosting, SSL, Domains, Security and 24/7 Technical Support." canonical="https://techalphassl.com/services" />
      <section className="pt-20 pb-10">
        <div className="container-page max-w-4xl">
          <span className="eyebrow">What we do</span>
          <h1 className="mt-4 text-4xl md:text-6xl font-semibold tracking-tighter">Six services. One team. Zero handoffs.</h1>
          <p className="mt-4 text-lg text-muted-foreground">Every service is delivered by a senior engineer with skin in the game.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="container-page grid gap-6 md:grid-cols-2">
          {SERVICES.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.id} className="card-elevated p-8" data-testid={`services-page-card-${s.id}`}>
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#1565FF]/10 text-[#1565FF] dark:bg-white/5 dark:text-[#4FC3F7]">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 text-2xl font-semibold tracking-tight">{s.title}</h3>
                <p className="mt-2 text-muted-foreground">{s.description}</p>
                <ul className="mt-6 grid gap-2">
                  {(details[s.id] || []).map((f, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm">
                      <Check className="h-4 w-4 text-[#1565FF] dark:text-[#4FC3F7]" /> {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex gap-2">
                  <Link to="/quote" className="btn-primary !py-2 !px-4 !text-sm" data-testid={`services-cta-quote-${s.id}`}>Request Quote</Link>
                  <Link to="/pricing" className="btn-ghost !py-2 !px-4 !text-sm">See Pricing</Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <TestimonialCarousel featured="services" />
    </>
  );
}
